module.exports = __webpack_public_path__ + "static/media/Group 3420.19ca2826.svg";